module.exports = __webpack_public_path__ + "img/new-guide-02-3.cd0f480e.png";